/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { B2BUnit, RoutingService } from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { CurrentItemService } from '../../shared/current-item.service';
import {OrgUnitService} from "../../../core/services";
import {ROUTE_PARAMS} from "../../../root/route-params";

@Injectable({
  providedIn: 'root',
})
export class CurrentUnitService extends CurrentItemService<B2BUnit> {
  constructor(
    protected override routingService: RoutingService,
    protected orgUnitService: OrgUnitService
  ) {
    super(routingService);
  }

  protected getParamKey() {
    return ROUTE_PARAMS.unitCode;
  }

  protected getItem(code: string): Observable<B2BUnit> {
    return this.orgUnitService.get(code);
  }

  getError(code: string): Observable<boolean> {
    return this.orgUnitService.getErrorState(code);
  }
}
